import FactManagementPage from "@/features/facts/components/FactManagementPage";

export default function NutritionFactsPage() {
  return (
    <FactManagementPage
      section="nutrition"
      type="nutrition"
      title="Nutrition Facts Management"
      description="Manage all the nutrition facts in one place."
    />
  );
}
